
import * as _ from "lodash";
import * as React from "react";
import * as S from "@styled";

import { ConditionalTriggerConfig } from "../../model/ITriggerData";
import { ValidationError, ValidationErrorType } from "../../model/ValidationData";
import { hasValidationError } from "../Helpers";
import TypeSelector, { ITypeSelectorModel } from "../TypeSelector";
import ConditionalTriggerProcessParameters from "./ConditionalTriggerProcessParameters";
import { InputMode } from "./TriggerInput";
import { TypedTriggerInput } from "./TypedTriggerInput";

const TriggerInput = TypedTriggerInput as new () => TypedTriggerInput<ConditionalTriggerConfig>;

export const ConditionalTrigger: React.FC<ConditionalTriggerProps> = (props) => {

    const selectedSubprocessGuid = _.get(props.existingParameters, "processGuid");

    let subprocessParameters = <div className="row"></div>;
    if (selectedSubprocessGuid) {
        if (!props.subProcesses.find((s) => s.value === selectedSubprocessGuid)) {
            subprocessParameters = (
                <S.WarningContainer>
                    <div className="alert alert-warning" role="alert"><p><strong>{FRENDS.Localizations.Warning}</strong> {FRENDS.Localizations.SubProcessHasBeenDeleted}</p>
                        <p>{selectedSubprocessGuid}</p>
                    </div>
                </S.WarningContainer>
            );
        } else {
            subprocessParameters = <>
                <div style={{ textAlign: "right" }}>
                    <S.OpenExternalLink href={`SubProcess/Edit/${selectedSubprocessGuid}`}>
                        {FRENDS.Localizations.OpenProcess} <i className="ci-external_link" />
                    </S.OpenExternalLink>
                </div>
                <hr />
                <ConditionalTriggerProcessParameters
                    elementId={props.id}
                    existingParameters={props.existingParameters}
                    selectedSubprocessGuid={selectedSubprocessGuid}
                />
            </>;
        }
    }

    return <div>
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="pollingInterval"
            label={FRENDS.Localizations.PollIntervalSeconds}
            inputMode={InputMode.number}
            minValue={1}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="limitToOneConcurrentExecution"
            label={FRENDS.Localizations.LimitConditionalToOneConcurrentExecution}
            inputMode={InputMode.boolean}
            elementId={props.id}
        />
        <S.Label>
            {FRENDS.Localizations.Subprocess}
        </S.Label>

        <TypeSelector
            placeholder={FRENDS.Localizations.SelectSubprocess}
            selectorModel={props.subProcesses}
            selectorValuesModel={props.subProcesses.map((x) => ({ value: x.value, label: x.label }))}
            id={props.id}
            onChange={props.onConditionalProcessSelected}
            selectedTypeId={selectedSubprocessGuid}
            className={hasValidationError(props.validationErrors, ValidationErrorType.SubprocessSelectionMissing) ? "has-error" : null}
        />
        {subprocessParameters}
    </div>;
};

interface ConditionalTriggerProps {
    id: string;
    existingParameters: any;
    subProcesses: ITypeSelectorModel[];
    validationErrors: ValidationError[];
    onConditionalProcessSelected: (selectedProcessGuid: string) => void;
}
